export const column = [
  { key: '1', headerName: 'S.No', field: 'S.No', hide: false, width: 150 },
  { key: '2', headerName: 'Role ID', field: 'id', hide: false, width: 150 },
  { key: '3', headerName: 'Role', field: 'name', hide: false, width: 250 },
  { key: '3', headerName: 'Role Response', field: 'role_response', hide: false, width: 450 },
  { key: '4', headerName: 'Status', field: 'status', hide: false, width: 200 },
];
